import Request from './request'

export default class Icon {
  constructor(url, classModifier, isIe11) {
    this.isIe11 = isIe11
    this.div = document.createElement('div')
    this.div.classList.add('svg-sprite')
    this.div.classList.add(`-${classModifier}`)

    document.body.insertBefore(this.div, document.body.childNodes[0])

    this.request = new Request(url)
    this.request.on('success', this.svgLoaded.bind(this))
    this.request.send()

    if (this.isIe11) {
      const ieReq = new Request(
        '/sites/default/files/icons/icon_select_map.svg',
      )
      ieReq.on('success', this.svgLoaded.bind(this))
      ieReq.send()
    }
  }

  iconSelectLoaded() {
    const icons = document.querySelector('#svg-icon-sprite')
    if (!this.drupalIconsLoaded && icons) {
      this.drupalIconsLoaded = true
      this.attachIeSvg(icons)
    }
  }

  svgLoaded(response) {
    if (this.isIe11) {
      const container = document.createElement('div')
      container.innerHTML = response
      this.attachIeSvg(container.querySelector('svg'))
    } else {
      this.div.innerHTML = response
    }
  }

  attachIeSvg(svg) {
    const result = document.createElement('svg')
    result.setAttribute('xmlns', 'http://www.w3.org/2000/svg')

    const symbols = svg.querySelectorAll('symbol')

    for (let i = 0; i < symbols.length; i++) {
      result.appendChild(symbols[i])
    }

    this.div.appendChild(result)
  }
}
